import { authRoles } from 'app/auth';
import i18next from 'i18next';
import en from './i18n/en';
import hu from './i18n/hu';
import LabMeasurementReaderTable from './table/LabMeasurementReaderTable';
import LabMeasurementReaderEditForm from './editform/LabMeasurementReaderEditForm';
import LabMeasurementReaderProvider from './component/LabMeasurementReaderProvider';

i18next.addResourceBundle('en', 'labMeasurementReader', en);
i18next.addResourceBundle('hu', 'labMeasurementReader', hu);

export default [
	{
		path: '/lab-measurement-reader/edit/:id/:tabKey?',
		// component: LabMeasurementReaderEditForm,
		component: () => (<LabMeasurementReaderProvider><LabMeasurementReaderEditForm /></LabMeasurementReaderProvider>),
		auth: authRoles.labMeasurementReader
	},
	{
		path: '/lab-measurement-reader/:sessionNameParam?',
		component: LabMeasurementReaderTable,
		auth: authRoles.labMeasurementReader
	}
];
